module.exports = __webpack_public_path__ + "img/w3_cykel_light.14ebb5d7.png";